/**
 * Copyright (C) Firstlight Media. All rights reserved.
 * All information contained herein is and remains the property of Firstlight Media.
 * The intellectual and technical concepts contained herein are proprietary
 * to Firstlight Media. Dissemination of this information or reproduction
 * of this material is strictly forbidden unless prior written permission
 * is obtained from Firstlight Media.
 */

import { PlayerBuilder } from '../PlayerBuilder';
import { AdPlayer } from '@quickplay/player-interface';
import { createIMACSAIAdsPlayer } from './csai/ImaCsaiAdsPlayer';
import { createIMASSAIAdsPlayer } from './ssai/ImaSsaiAdsPlayer';

export function createIMAAdPlayer(builder: PlayerBuilder): AdPlayer {
  if (builder.imaDaiStreamManager) {
    return createIMASSAIAdsPlayer(builder);
  }

  return createIMACSAIAdsPlayer(builder);
}
